export const updateUrlVersion = (url: string, version: string) =>
  url.replace(/\/v\d+\//, `/v${version}/`);
